import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const slice = createSlice({
  name: '$includeDiscountMinSpend',
  initialState,
  reducers: {
    setIncludeDiscountMinSpend(state, action: PayloadAction<boolean>) {
      return Boolean(action.payload);
    },
  },
});

export const { setIncludeDiscountMinSpend } = slice.actions;
export default slice.reducer;
